import { exists } from '@/api'

export interface SystemParameter {
  id: number
  codeKey: string
  code: string
  name: string
  shortName: string
  option1: string
  option2: string
  option3: string
  option4: string
  option5: string
  option6: string
}

export function SystemParameterFromJSON(json: any): SystemParameter {
  return {
    id: exists(json, 'id') ? json.id : 0,
    codeKey: exists(json, 'parameter_key') ? json.parameter_key : '',
    code: exists(json, 'code') ? json.code : '',
    name: exists(json, 'name') ? json.name : '',
    shortName: exists(json, 'short_name') ? json.short_name : '',
    option1: exists(json, 'option1') ? json.option1 : '',
    option2: exists(json, 'option2') ? json.option2 : '',
    option3: exists(json, 'option3') ? json.option3 : '',
    option4: exists(json, 'option4') ? json.option4 : '',
    option5: exists(json, 'option5') ? json.option5 : '',
    option6: exists(json, 'option6') ? json.option6 : ''
  }
}

export function SystemParameterToJSON(value: SystemParameter): any {
  return {
    id: value.id,
    parameter_key: value.codeKey,
    code: value.code,
    name: value.name,
    short_name: value.shortName,
    option1: value.option1,
    option2: value.option2,
    option3: value.option3,
    option4: value.option4,
    option5: value.option5,
    option6: value.option6
  }
}

export const defaultSystemParameter = (): SystemParameter => ({
  id: 0,
  codeKey: '',
  code: '',
  name: '',
  shortName: '',
  option1: '',
  option2: '',
  option3: '',
  option4: '',
  option5: '',
  option6: ''
})
